import React, {useState} from "react";
import SkillsTable from "../table/SkillsTable";
import RadarChartComponent from "../charts/RadarChartComponent";
import ComparisonTable from "../table/ComparisonTable";
import SkillsNote from "../table/SkillsNote";
import {Element} from "react-scroll";

interface AssessmentResultsProps {
    title: string,
    questions?: question[],
    groups: group[],
    highSkills?: group[];
    lowSkills?: group[];
    comparison?: group[];
    feedback?: string
    templateAnswerResult?: string
    activeTemplate?: boolean
    answerTime?: string
}

interface question {
    title: string,
    answer: string,
    type: number
}

interface group {
    groupTitle: string,
    totalPoint: number,
    totalQuestion: number,
    advice: string,
    avgPoint: number,
    stdevpPoint: number,
    deviation: number,
    exposition: string,
    isLowSkill?: string
    acronym?: string
}

const SummaryWithChart: React.FC<{ data: AssessmentResultsProps, content?: Record<string, (string|boolean)[]>, defaultTemplate?: boolean}> = ({ data, content, defaultTemplate }) => {
    const [processing , setProcessing] = useState<boolean>(true);
    const [dataGroupRadar , setDataGroupRadar] = useState<group[]>(data.groups);
    const [dataGroupTable , setDataGroupTable] = useState<group[]>(data.groups);
    if((content?.CHART?.[0] || content?.SKILLS_TABLE?.[0]) && processing && !defaultTemplate){
        const selectedIndices = parseGroupString(content?.CHART?.[0]+'');
        if(Number.isNaN(selectedIndices[0]))
            setDataGroupRadar(data.groups)
        else
            setDataGroupRadar(data.groups.filter((_, index) => selectedIndices.includes(index + 1)))
        const selectedIndicesTable = parseGroupString(content?.SKILLS_TABLE?.[0]+'');
        if(Number.isNaN(selectedIndicesTable[0]))
            setDataGroupTable(data.groups)
        else
            setDataGroupTable(data.groups.filter((_, index) => selectedIndicesTable.includes(index + 1)))
        setProcessing(false);
    }
    return data &&
        <>
            <Element name="general">
                <div className={"div-section"} style={{marginTop: '48px'}}>
                    <div style={{height: '45px'}}>
                        <span className="title-section">
                            {  content?.TITLE?.[0] ? typeof content?.TITLE?.[0] != 'boolean' ? content?.TITLE?.[0] : 'サマリ' : 'サマリ'}
                        </span>
                    </div>

                    <div className={"border-title"}>
                        <div className={"underline-title"}></div>
                    </div>

                    <div style={{fontSize: '16px'}}>
                        <div className="pt-4">
                            <div className="pb-4">
                            <span style={{whiteSpace: 'break-spaces' }}>
                                {
                                    content?.TEXT?.[0]
                                }
                            </span>
                            </div>
                        </div>
                        <div className={'d-flex'}>
                            {
                                (content?.CHART?.[0] || defaultTemplate) && dataGroupRadar &&
                                <>
                                    <div>
                                        <RadarChartComponent data={dataGroupRadar} />
                                    </div>
                                    <SkillsNote data={dataGroupRadar} />
                                </>

                            }

                        </div>
                        {
                            (content?.SKILLS_TABLE?.[0] || defaultTemplate) && dataGroupTable && <SkillsTable data={dataGroupTable}/>
                        }
                        {
                            data.comparison && (content?.COMPARISION?.[0] || defaultTemplate) && <ComparisonTable data={data.comparison} />
                        }
                    </div>
                </div>
            </Element>
        </>
}

const parseGroupString = (str: string): number[] => {
    const result: number[] = [];

    str.split(',').forEach(part => {
        if (part.includes('-')) {
            const [start, end] = part.split('-').map(Number);
            for (let i = start; i <= end; i++) {
                result.push(i);
            }
        } else {
            result.push(Number(part));
        }
    });

    return result;
};
export default SummaryWithChart;
